exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.invoice_notice[data-v-3e9cd09c]{\n  color:#f00;\n  font-weight:bold;\n}\n", ""]);

// exports
